import React from 'react'

export const BackButton = ({ props }) => {

    const handleBack = () => {
        sessionStorage.setItem('is_navigating_back', 'true');
        if (props?.history?.goBack) {
            props.history.goBack();
        } else {
            window.history.back();
        }
    };

    return (
        <>
            <div className="d-flex align-items-center justify-content-end mb-2">
                <button onClick={handleBack} className="btn btn-success rounded-3 py-2">
                    <span className="mdi mdi-keyboard-backspace me-2"></span>Atrás
                </button>
            </div>
        </>
    )

}
